import { useMutation, useQueryClient } from '@tanstack/react-query';
import addressApiClient from './addressApi-client';
import apiClient from './api-client';
const SCOPE = 'address';
const DETAIL = 'detail';
let currentSessionToken = '';
const keysFactory = {
    all: (financingProgramId) => [{ scope: SCOPE, financingProgramId }],
    allDetails: (financingProgramId) => [{ scope: SCOPE, entity: DETAIL, financingProgramId }],
    detail: (id, financingProgramId) => [{ scope: SCOPE, entity: DETAIL, id, financingProgramId }],
};
const decodeJwt = (token) => {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const decodedString = atob(base64);
    const payload = JSON.parse(decodedString);
    const jwtToken = {
        exp: payload.exp,
    };
    return jwtToken;
};
const getSessionToken = async (recaptcha, financingProgramId) => {
    if (currentSessionToken) {
        try {
            const decoded = decodeJwt(currentSessionToken);
            const expirationDate = new Date(decoded.exp * 1000);
            const nowUTC = new Date(new Date().toISOString());
            if (nowUTC < expirationDate) {
                return currentSessionToken;
            }
        }
        catch (error) {
            console.error('Failed to decode JWT:', error);
        }
    }
    const options = {
        headers: { 'x-recaptcha-token': recaptcha },
    };
    const response = await apiClient.post(`${financingProgramId}/startSession`, {}, options);
    const newToken = response.data;
    currentSessionToken = newToken;
    return currentSessionToken;
};
const getAddressSuggestion = async (dto, financingProgramId) => {
    const bearerToken = await getSessionToken(dto.recaptchaToken, financingProgramId);
    const filteredDto = {
        addressInput: dto.addressInput,
        sessionToken: bearerToken,
    };
    const options = {
        headers: { Authorization: `bearer ${bearerToken}` },
    };
    const response = await addressApiClient.post(`Address/Suggestions`, filteredDto, options);
    return response.data;
};
export function useAddressSuggestion(financingProgramId) {
    const queryClient = useQueryClient();
    const { mutateAsync, isPending, reset } = useMutation({
        mutationFn: (dto) => getAddressSuggestion(dto, financingProgramId),
        onSuccess: (data) => {
            queryClient.setQueryData(keysFactory.detail(data.sessionToken, financingProgramId), data);
            return data;
        },
    });
    return [mutateAsync, isPending, reset];
}
const addressDetail = async (dto, financingProgramId) => {
    const bearerToken = await getSessionToken(dto.recaptchaToken, financingProgramId);
    const bearer = `bearer ${bearerToken}`;
    const options = {
        headers: {
            Authorization: bearer,
        },
    };
    const filteredDto = {
        placeId: dto.placeId,
        userLanguageCode: dto.userLanguageCode,
        sessionToken: bearerToken,
    };
    const response = await addressApiClient.post(`Address/Details`, filteredDto, options);
    return response.data;
};
export function useAddressDetail(financingProgramId) {
    const queryClient = useQueryClient();
    const { mutateAsync, isPending, reset } = useMutation({
        mutationFn: (dto) => addressDetail(dto, financingProgramId),
        onSuccess: (data) => {
            queryClient.setQueryData(keysFactory.detail(data.sessionToken, financingProgramId), data);
            return data;
        },
    });
    return [mutateAsync, isPending, reset];
}
